import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { SvgComponent } from '../../assets';
import { theme } from '../../theme';
import { UIText } from '../typography';

type BasePillProps = PropsWithChildren<{
  backgroundColor?: string;
  icon?: SvgComponent;
  iconFill?: string;
  color?: string;
  onClick?: () => void;
  className?: string;
}>;

const PillBase = styled(UIText).attrs({
  size: 'xs',
})<BasePillProps>`
  box-sizing: border-box;
  text-align: center;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacings[1].rem};
  padding: ${theme.spacings[1].rem} ${theme.spacings[3].rem};
  border-radius: ${theme.borderRadius.rounded};
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color};
`;

export const Pill: React.FC<BasePillProps> = ({
  children,
  backgroundColor,
  icon: Icon,
  iconFill = theme.colors.primary.graysGray,
  color = theme.colors.primary.graysGray,
  onClick,
  className,
}) => (
  <PillBase
    onClick={onClick}
    backgroundColor={backgroundColor}
    color={color}
    className={className}
  >
    {Icon && <Icon fill={iconFill} width={16} />}
    {children}
  </PillBase>
);
